var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"railway-control"},[_c('r-main-panel',[_c('railway-control-list')],1),_c('railway-control-content'),(_vm.isCardActive)?_c('railway-control-card'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }